import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { QuickbetPanelComponent } from '../quickbetPanel/quickbet-panel.component';

@Component({
    selector: 'quickbet-panel-updated',
    templateUrl: 'quickbet-panel-updated.component.html',
    styleUrls: ['../quickbetPanel/quickbet-panel.component.scss', 'quickbet-panel-updated.component.scss'],
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class QuickbetPanelUpdatedComponent extends QuickbetPanelComponent implements OnInit, OnDestroy {
    @Output() readonly openFullOverlayFn: EventEmitter<void> = new EventEmitter();
    @Output() readonly closePanelFn: EventEmitter<void> = new EventEmitter();
    @Input() override isQuickBet: boolean;
    @Input() showFullOverlay: boolean;
    nativeIos: boolean = false;
    NWIndicatorShown: boolean = false;
    showQuickBet: boolean = true;
    closeQuickbetPanelDelay: number = 500;
    override title = 'QuickbetPanelUpdatedComponent';
    readonly quickBetExtendedClass: string = 'quickbet-extended-opened';
    readonly nwIndicatorShown: string = 'nw-indicator-shown';
    readonly srmBetClass: string = 'srm-bet-opened';

    override ngOnInit(): void {
        super.ngOnInit();
        this.sessionStorageService.set('QUICK_BET_OPENED', true);
        this.showFullOverlay && this.openFullOverlay();
        const currentURL: string = this.router.url;

        if (currentURL.indexOf('footballsuperseries') > -1) {
            this.showQuickBet = false;
        }

        this.pubsub.subscribe(this.title, 'NW_INDICATOR_DISPLAY', (NWIndicatorShown: boolean) => {
            this.nativeIos = false;
            this.NWIndicatorShown = NWIndicatorShown;
            this.addOrRemoveBodyClass(this.NWIndicatorShown, this.nwIndicatorShown);
            if (this.checkIsNativeIos()) {
                this.nativeIos = true;
            }
            this.changeDetectorRef.markForCheck();
        });

        this.pubsub.subscribe(
            this.title,
            [this.pubsub.API.TOGGLE_MOBILE_HEADER_FOOTER, this.pubsub.API.QUICKBET_PARTIAL_OVERLAY_SHOW],
            (state: boolean) => this.toggleQuickBet(state),
        );

        this.pubsub.subscribe(this.title, this.pubsub.API.GAMING_OVERLAY_OPEN, () => {
            this.showQuickBet = false;
        });

        if (this.isSRMBet) {
            this.addOrRemoveBodyClass(true, this.quickBetExtendedClass);
            this.addOrRemoveBodyClass(true, this.srmBetClass);
        }
    }

    private toggleQuickBet(state: boolean): void {
        this.showQuickBet = state;
        this.changeDetectorRef.detectChanges();
    }

    private checkIsNativeIos(): boolean {
        const isIosWrapper = this.device.isIos && this.device.isWrapper;
        return this.NWIndicatorShown && isIosWrapper;
    }

    openFullOverlay(): void {
        this.toggleBodyScroll(true);
        this.addOrRemoveBodyClass(true, this.quickBetExtendedClass);
        this.showFullOverlay = true;
        this.openFullOverlayFn.emit();
    }

    removeSelection(): void {
        this.slideDownAnimation = true;
        this.pubsub.publish(this.pubsub.API.ODDS_BOOST_CHANGE, false);
        // Delayed emit to display slide down(animation) for close quickbet panel
        this.windowRefService.nativeWindow.setTimeout(() => {
            this.closePanelFn.emit();
        }, this.closeQuickbetPanelDelay);
    }

    addOrRemoveBodyClass(state: boolean, className: string): void {
        if (this.windowRefService.document.body) {
            state
                ? this.rendererService.renderer.addClass(this.windowRefService.document.body, className)
                : this.rendererService.renderer.removeClass(this.windowRefService.document.body, className);
        }
    }

    override ngOnDestroy(): void {
        this.addOrRemoveBodyClass(false, this.quickBetExtendedClass);
        this.isSRMBet && this.addOrRemoveBodyClass(false, this.srmBetClass);
        this.pubsub.unsubscribe(this.title);
        (this.showFullOverlay || this.isSRMBet) && this.toggleBodyScroll(false);
        super.ngOnDestroy();
    }
}
